import { AfterViewInit, Directive, ElementRef, Input, OnDestroy } from '@angular/core';
import { MaxWidth, ResponsiveService } from './responsive.service';
import { Subscription } from 'rxjs';
import { util } from '../util';

@Directive({
  selector: '[maxWidth]'
})
export class MaxWidthDirective implements AfterViewInit, OnDestroy {
  @Input() public maxWidth:MaxWidth;

  private onSetWidthSubscription:Subscription;

  constructor(
    private responsiveService:ResponsiveService,
    private elementRef:ElementRef<HTMLElement>
  ) {
    /**/
  }

  public ngAfterViewInit():void {
    let initialWidth:MaxWidth = this.responsiveService.width;
    if (util.isNullOrUndefined(initialWidth)) {
      initialWidth = this.maxWidth;
    }
    // init class
    this.addClass(initialWidth);

    // register listener
    this.listen();
  }

  private listen():void {
    this.onSetWidthSubscription = this.responsiveService.onSetWidth.subscribe((width:MaxWidth) => {
      this.addClass(width);
    });
  }

  private addClass(width:MaxWidth):void {
    const element:JQuery<HTMLElement> = $(this.elementRef.nativeElement);
    element.removeClass(MaxWidth.SM);
    element.removeClass(MaxWidth.MD);
    element.removeClass(MaxWidth.LG);

    if ([MaxWidth.SM, MaxWidth.MD].indexOf(width) > -1) {
      element.addClass(width);
    } else {
      element.addClass(MaxWidth.LG);
    }
  }

  public ngOnDestroy():void {
    this.onSetWidthSubscription?.unsubscribe();
  }
}